import cloud from "../cloud";

/**
 * 从千牛中转服务器获取发货易登录token
 */
export async function getSETokenFromQn() {
    const token = (await cloud.application.httpRequest({
        path: "/token",
        method: "GET",
        body: {},
        params: {},
        headers: {},
        exts: {
            timeout: 10000,
        },
    })) as string;

    return token;
}
